// js/lib/firebase.js
// Firebase config is injected at build time via Vite environment variables.
// Values come from .env.staging or .env.production depending on build mode.
//
// Local dev:         npm run dev            (uses .env.staging)
// Build staging:     npm run build:staging
// Build production:  npm run build:production

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
storage.maxUploadRetryTime = 15000;
storage.maxOperationRetryTime = 10000;
const functions = getFunctions(app);
const billingFunctions = getFunctions(app, "europe-west1");
export { httpsCallable };
const storageUploadsEnabled = import.meta.env.VITE_STORAGE_ENABLED !== "false";

// Memory-only cache — the app has its own sessionStorage cache (cache.js) with
// per-entry TTLs that already covers repeat-visit performance. The Firestore
// persistentLocalCache (IndexedDB) is redundant here and causes an auth token
// race condition on first load: reads are served from IndexedDB before the
// server connection has the auth token, so writes fail with "permission-denied".
const db = initializeFirestore(app, {});

export {
  app,
  auth,
  db,
  storage,
  functions,
  billingFunctions,
  storageUploadsEnabled,
};
